import * as types from '../constants/ActionTypes';
import * as consts from '../constants';
import { includes } from 'lodash';

export function setApplicationMode(mode) {
mode = includes(consts.applicationModes, mode) ? mode : consts.applicationModes.INDEX;
  return {
    type: types.SET_APP_MODE,
    mode: mode
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/ApplicationModeActions.js
 **/